<template>
  <div>
    <div class="instruct" v-if="true">
      <h4>Instructions</h4>
      <p>You are given <strong>{{ model.response.length }} definitions</strong> to choose from. Please use the definition selector to match a definition to the term.</p>
    </div>
    <ul class="list">
      <li class="item" v-for="definition in model.response">
        <definition :definition="definitions[definition.definitionId]" />
        <selector v-model="definition.answerDefinitionId" @input="doit(definition)" :available="availableDefinitions" :all="model.question.definitions" v-if="respondable" />
        <div :class="['answer', (definition.definitionId === definition.answerDefinitionId) ? 'correct' : 'incorrect']" v-else>
          <h6 class="answer__label">Your Response</h6>
          <div :class="['answer', (definition.definitionId === definition.answerDefinitionId) ? 'selected' : '']">
            <div class="answer__response">
              <span class="bullet" :class="['answer', (definition.definitionId === definition.answerDefinitionId) ? 'correct' : 'incorrect']">
                <sprite name="iconClose" v-if="definition.definitionId !== definition.answerDefinitionId" />
                <sprite name="iconCheck" v-if="definition.definitionId === definition.answerDefinitionId" />
              </span>
              {{ definitions[definition.answerDefinitionId] ? definitions[definition.answerDefinitionId].definition : '' }}
            </div>
          </div>
          <div class="answer__correct" v-if="definition.definitionId !== definition.answerDefinitionId">
            <h6 class="answer__label">Correct Response</h6>
            <div class="answer__response">
              <span class="bullet" :class="['answer', (definition.definitionId !== definition.answerDefinitionId) ? 'correct' : 'incorrect']">
                <sprite name="iconCheck" />
              </span>
              {{ definitions[definition.definitionId] ? definitions[definition.definitionId].definition : '' }}
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>

  import Definition from "./definition"
  import Selector from "./selector"

  export default {
    name: 'vocab',
    props: {
      model: Object,
      respondable: Boolean
    },
    components: { Definition, Selector },
    data () {
      return {
        definitions: _.reduce(this.model.question.definitions, (definitions, definition) => {
          definitions[definition.id] = definition
          return definitions
        }, {})
      }
    },
    computed: {
      availableDefinitions () {
        const used = _.map(this.model.response, (response) => {
          return +response.answerDefinitionId
        })
        return this.model.question.definitions.filter((definition) => {
          return !used.includes(definition.id)
        })
      }
    },
    methods: {
      doit (d) {
        this.model.DSSave()
      }
    }
  }
</script>

<style lang="scss" scoped>

  @import "~globals";

  h4 {
    @include font-size(medium, $headline:true);
    margin-bottom:1rem;
  }

  h6 {
    @include font-size(xxsmall, $headline:true);
    margin-bottom:1rem;
  }

  .bullet {
    @include bullet();
  }

  .list {
    margin:0; padding:0; list-style:none;
  }

  .item {
    background:#fff; box-shadow:$box-shadow; padding:2rem;
  }
  .item + .item {
    margin-top:1.5rem;
  }

  .instruct {
    margin-bottom:2rem;
  }

  .answer {

    &__label {
      margin-bottom:.25em;
    }

    &__response {
      display:flex; align-items:center;
    }

    &__correct {
      margin-top:1em;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/VisualVocab/index.vue